<template>
  <router-link :to="{ path: `play?t=${this.timeCode}` }" tag="div" class="chapter-card" :style="{'background-image': `url(${require('@/assets/thumbnails/' + this.thumbnail)})`}">
    <div class="chapter-duration">
      <span class="duration-label">{{ time }}</span>
    </div>
    <div class="chapter-title">{{ this.title }}</div>
  </router-link>
</template>

<script>
export default {
  name: 'ChapterCard',

  props: {
    title: String,
    thumbnail: {
      type: String,
      required: true
    },
    duration: Number,
    timeCode: Number
  },

  computed: {
    time: function () {
      return `${~~(this.duration / 60)}:${(this.duration % 60 < 10 ? 0 : '')}${this.duration % 60}`
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  .chapter-card {
    transition: box-shadow 0.3s ease-in-out;
    justify-content: space-between;
    background-position: center;
    background-size: cover;
    flex-direction: column;
    border-radius: .5rem;
    min-height: 170px;
    cursor: pointer;
    display: flex;

    &:hover {
      box-shadow: 0 0 30px 0 rgba(0, 0, 0, .5);
    }

    .chapter-duration {
      padding: .75rem;
      text-align: right;

      .duration-label {
        padding: .25rem .5rem;
        display: inline-block;
        border-radius: 2rem;
        font-size: .75rem;
        font-weight: 900;
        background: #000;
      }
    }

    .chapter-title {
      background-image: linear-gradient(-180deg, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 1) 100%);
      padding: .75rem .75rem .5rem;
      text-transform: uppercase;
      border-radius: .5rem;
      font-size: .875rem;
      text-align: right;
      font-weight: 700;
    }
  }
</style>
